export default "__VITE_ASSET__B9yIhvs8__"